import * as SettingsActions from '../actions/settings.actions';
import * as moment from 'moment-timezone';
import { TagEnum } from '../../../settings/models/tag.enum';
import { SettingsModel } from '../../../core/models/settings.model';
import jwt_decode from 'jwt-decode';
import { environment } from '../../../../environments/environment';

export interface State {
  timeZone: string;
  settings: SettingsModel[];
}

export const initialState: State = {
  timeZone: localStorage.getItem(`${environment.storagePrefix}.timeZone`) || moment.tz.guess(),
  settings: [],
};

export function reducer(
  state = initialState,
  action: SettingsActions.SettingsActionsUnion
): State {
  switch (action.type) {
    case SettingsActions.setTimeZone.type: {
      return {
        ...state,
        timeZone: action['timeZone']
      };
    }
    case SettingsActions.getTagSuccess.type:
    case SettingsActions.editTagSuccess.type: {
      // FIXME zrobić tak żeby obejmowało wszystkie ustawienia

      const settings = [...state.settings];
      const item = {...action.data, key: action.data.key.toUpperCase()};
      const index = settings.findIndex(x => x.key === item.key);
      if (index > -1) {
        settings[index] = item;
      } else {
        settings.push(item);
      }
      return {
        ...state,
        settings: settings
      };
    }
    case SettingsActions.changeUserAccountSuccess.type: {
      const settings = [...state.settings];
      if (action.data && action.data.newEmail) {
        const index = settings.findIndex(x => x.key.toUpperCase() === TagEnum.Email.name.toUpperCase());
        if (index > -1) {
          settings[index].value = JSON.stringify(action.data.newEmail);
          settings[index].key = settings[index].key.toUpperCase();
        }
      }
      return {
        ...state,
        settings: settings
      };
    }
    case SettingsActions.deleteTagSuccess.type: {
      const settings =  [...state.settings];
      const index = settings.findIndex(x => x.key === action.tagName);
      if (index > -1) {
        settings[index].value = JSON.stringify('');
      }
      return {
        ...state,
        settings: settings
      };
    }
    case SettingsActions.getSettingsTagsSuccess.type: {
      const newSettings = [...action.data];
      newSettings.forEach(item => item.key = item.key.toUpperCase());
      return {
        ...state,
        settings: newSettings
      };
    }
    case SettingsActions.getTagsSuccess.type:
    case SettingsActions.editTagsSuccess.type: {
      const settings = [...state.settings];
      action.data.forEach((item: SettingsModel) => {
        const data = {...item, key: item.key.toUpperCase()}
        const i = settings.findIndex((x: SettingsModel) => x.key.toUpperCase() === data.key);
        if (i > -1) {
          settings[i] = data;
        } else {
          settings.push(data);
        }
      });

      return {
        ...state,
        settings: settings
      };
    }
    case SettingsActions.decodeFromToken.type: {
      // let settings: SettingsModel[] = new Array<SettingsModel>();
      const user = JSON.parse(localStorage.getItem(`${environment.storagePrefix}.currentUser`));
      const decodedToken = jwt_decode(user.accessToken);
      const settingsMap: Map<string, string> = JSON.parse(decodedToken['settings']);
      const settings: SettingsModel[] = Object.keys(settingsMap).map((key) => {
        return {
          key: key.toUpperCase(),
          value: settingsMap[key],
          regexPattern: null,
          targetIdentifier: null,
          targetName: null
        }
      });
      const timeZoneSettings = settings.find(x => x.key === TagEnum.TimeZone.name);
      let timeZone = null;
      timeZone = timeZoneSettings?.value || localStorage.getItem(`${environment.storagePrefix}.timeZone`) || moment.tz.guess();
      localStorage.setItem(`${environment.storagePrefix}.timeZone`, timeZone);
      moment.tz.setDefault(timeZone);
      return {
        ...state,
        settings: settings,
        timeZone: timeZone
      };
    }
    default: {
      return state;
    }
  }
}
export const getLanguage = (state: State) => state.settings.filter((res) => (res.key === TagEnum.Language.name.toUpperCase()));
export const getTimeZone = (state: State) => state.timeZone;
export const getSettings = (state: State) => state.settings;
export const getTag = (state: State, tagName: string) => state.settings.find((res) => res.key.toUpperCase()  === tagName.toUpperCase());
